export function idsFromSelectionMap(selected) {
  if (!selected || typeof selected !== "object") return [];
  return Object.keys(selected).filter((key) => selected[key]);
}

export function selectedCount(selected) {
  if (!selected || typeof selected !== "object") return 0;
  return Object.values(selected).filter(Boolean).length;
}

export function selectionMapFromAgGridEvent(event, { getId } = {}) {
  const nextSelected = {};
  const nodes = event?.api?.getSelectedNodes?.() || [];
  nodes.forEach((node) => {
    const data = node?.data;
    const id = getId ? getId(data) : data?.id;
    if (id === null || id === undefined) return;
    nextSelected[id] = true;
  });
  return nextSelected;
}

export function pruneSelectionMap(selected, validIds) {
  const current = selected && typeof selected === "object" ? selected : {};
  const valid = validIds instanceof Set ? validIds : new Set(validIds || []);
  const next = {};
  Object.keys(current).forEach((key) => {
    if (current[key] && valid.has(String(key))) {
      next[key] = true;
    }
  });
  const currentKeys = Object.keys(current).filter((key) => current[key]);
  const nextKeys = Object.keys(next);
  return currentKeys.length === nextKeys.length ? current : next;
}
